import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { ROUTES } from '@/shared/config';
import { PageHeader, ScrollArea, Skeleton } from '@/shared/ui';

/**
 * Экран, пока грузится чанк страницы (`lazyPage` в `app/router`): тот же
 * каркас и тот же скелет, что `IdiomDetailPage` показывает, пока ждёт
 * идиому, — загрузка кода и данных идёт одним шиммером.
 */
export function IdiomDetailPageSkeleton() {
  const { t } = useTranslation('IdiomDetailPage');
  const navigate = useNavigate();
  return (
    <div className="flex h-dvh flex-col text-ink">
      <PageHeader title={t('headerTitle')} onBack={() => void navigate(ROUTES.home)} />
      <div aria-hidden="true" className="h-[calc(var(--status-bar-top)+var(--header-band-height))] shrink-0" />
      <IdiomSkeleton />
    </div>
  );
}

/** Форма один в один с загруженной страницей — иконка, заголовок, карточка с переводом и примером, кнопка. */
export function IdiomSkeleton() {
  const { t } = useTranslation('IdiomDetailPage');
  return (
    <>
      <ScrollArea className="px-5" contentClassName="flex flex-col items-center pt-4 pb-6 text-center">
        <div aria-busy="true" aria-live="polite" className="flex w-full flex-col items-center">
          <span className="sr-only">{t('loadingSr')}</span>

          <Skeleton className="size-24 rounded-3xl" />
          <Skeleton className="mt-4 h-8 w-56" />

          <Skeleton className="mt-6 h-40 w-full rounded-2xl" />
        </div>
      </ScrollArea>

      <div className="shrink-0 px-5 pt-2 pb-[calc(var(--safe-bottom)+1rem)]">
        <Skeleton className="h-14 w-full rounded-full" />
      </div>
    </>
  );
}
